module.exports = __webpack_public_path__ + "media/customizations/regencyatfolsomranch/logo-9fc1b05106aefafc5422b4f785a24d89.png";